import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { GenericRosterComponent } from '../generic-roster/generic-roster.component';
import { StudentCardComponent } from './student-card.component';
import {
  School,
  SchoolRosterFilter,
  SchoolTermGradeDto,
  SchoolGradeYearDto,
  AttendanceType,
  IssueRestrictedFields,
  SchoolRosterStudent
} from '@k12/models';
import { SchoolsService } from '@k12/school-services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-not-yet-endorsed-roster',
  template: `
    <lib-generic-roster
      [currentSchool]="currentSchool"
      [editable]="editable"
      [showAdminActions]="showAdminActions"
      [disableBackwardMove]="disableBackwardMove"
      [schoolTermId]="schoolTermId"
      [termName]="termName"
      [academicYearId]="academicYearId"
      [reloadTrigger]="reloadTrigger"
      [studentCardComponent]="studentCardComponent"
      [loadStudentsQuery]="loadStudentsQuery"
      [exportQuery]="exportQuery"
      [importQuery]="importQuery"
      [rosterTitle]="rosterTitle"
      [schoolTermGrades]="schoolTermGrades"
      [schoolGradeYears]="schoolGradeYears"
      [attendanceTypes]="attendanceTypes"
      [emptyStateMessage]="emptyStateMessage"
      [searchTerm]="searchTerm"
      [issueRestrictions]="issueRestrictions"
      (countChanged)="countChanged.emit($event)"
      (endorsed)="endorsed.emit($event)"
      (saved)="saved.emit($event)"
      (reverted)="reverted.emit($event)"
      (withdrawalRequested)="onWithdrawal($event)">
    </lib-generic-roster>
  `,
  standalone: true,
  imports: [GenericRosterComponent]
})
export class NotYetEndorsedComponent {
  @Input() currentSchool: School | null = null;
  @Input() editable = false;
  @Input() showAdminActions = false;
  @Input() disableBackwardMove = false;
  @Input() schoolTermId: string | null = null;
  @Input() termName: string | null = null;
  @Input() academicYearId: number | null = null;
  @Input() reloadTrigger: number = 0;
  @Input() schoolTermGrades: SchoolTermGradeDto[] = [];
  @Input() schoolGradeYears: SchoolGradeYearDto[] = [];
  @Input() attendanceTypes: AttendanceType[] = [];
  @Input() emptyStateMessage: string = 'No students are pending endorsement.';
  @Input() searchTerm: string = '';
  @Input() issueRestrictions: IssueRestrictedFields | null = null;
  @Output() countChanged = new EventEmitter<number>();
  @Output() endorsed = new EventEmitter<string>();
  @Output() saved = new EventEmitter<string>();
  @Output() reverted = new EventEmitter<string>();
  @Output() withdrawalRequested = new EventEmitter<SchoolRosterStudent>();

  get studentCardComponent() {
    return StudentCardComponent;
  }

  private readonly schoolsService: SchoolsService = inject(SchoolsService);
  loadStudentsQuery = (filters: SchoolRosterFilter) => this.schoolsService.getNotYetEndorsedRosters(filters);
  exportQuery = (mini: boolean, schoolTermId?: string | null) =>
    this.schoolsService.exportNotYetEndorsedRoster(this.currentSchool!.programPartnerId!, mini, schoolTermId, this.academicYearId);
  importQuery = (file: File, schoolTermId?: string | null) =>
    this.schoolsService.importRoster(this.currentSchool!.programPartnerId!, file, schoolTermId);
  rosterTitle = 'Not Yet Endorsed';

  protected onWithdrawal(student: SchoolRosterStudent): void {
    this.withdrawalRequested.emit(student);
  }
}
